/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

// document.addEventListener('DOMContentLoaded', function() {
//   const scrollToTopButton = document.querySelector('.scroll-to-top');

//   // Function to show or hide the scroll-to-top button based on scroll position
//   function toggleScrollToTopButton() {
//     if (window.scrollY > 200) { // Adjust this value to change when the button appears
//       scrollToTopButton.style.display = 'block';
//     } else {
//       scrollToTopButton.style.display = 'none';
//     }
//   }

//   // Add event listener to window scroll event
//   window.addEventListener('scroll', toggleScrollToTopButton);

//   // Initially hide the button if user is already at the top of the page
//   toggleScrollToTopButton();
// });

document.addEventListener('DOMContentLoaded', function() {
  const scrollToTopButton = document.querySelector('.scroll-to-top');

  // Function to show or hide the scroll-to-top button based on scroll position
  function toggleScrollToTopButton() {
    const scrollY = window.scrollY;
    const maxScroll = (document.documentElement.scrollHeight - window.innerHeight) * 0.7;

    console.log(scrollY, 'scrollY');
    console.log(maxScroll, 'maxScroll')

    if (scrollY > maxScroll) { 
      scrollToTopButton.style.display = 'block';
    } else {
      scrollToTopButton.style.display = 'none';
    }
  }

  // Add event listener to window scroll event
  window.addEventListener('scroll', toggleScrollToTopButton);

  // Initially hide the button if user is already at the top of the page
  toggleScrollToTopButton();
});
